/** Default fun facts (same list as lib/wall/facts.ts). */
export const WALL_DEFAULT_FACTS = [
  "Score in classic modes increases at a fixed rate (60 points per second) while you stay alive.",
  "Progression mode can reach level 200 with up to 256 balls on screen.",
  "Superdot push (R) flings every ball away from your cursor for five seconds.",
  "SpeedRun leaderboard times are stored in milliseconds — lower is better.",
  "Sandbox presets can be published publicly for other players to discover.",
  "Roulette mode picks a random chaos effect roughly every ten seconds.",
  "Highway mode scrolls infinitely upward — the camera never stops moving.",
  "Signed-in players sync records, settings, and achievements via the cloud.",
  "The sidebar opens with E on desktop or the MENU button on touch devices.",
  "WASD mode adds five new balls every 100 points you score.",
  "In POP mode, same-size balls split; large-or-bigger balls also split with each other; minis fuse with no size cap.",
  "Ball bounce speed in Normal mode multiplies by 1.08 on each wall hit.",
  "You can install CursorGame as a PWA on mobile and desktop.",
] as const;

export function pickFromFactPool(pool: readonly string[], seed?: string): string {
  if (!pool.length) return "";
  if (!seed) return pool[Math.floor(Math.random() * pool.length)]!;
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0;
  return pool[Math.abs(h) % pool.length]!;
}

export function blockFactPool(data: Record<string, unknown>): string[] {
  if (!Array.isArray(data.facts)) return [];
  return data.facts.filter((x): x is string => typeof x === "string" && x.trim().length > 0);
}
